import React from 'react';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';

interface QuestionPreviewContainerProps {
  children: React.ReactNode;
  sx?: SxProps;

  optionType?: 'positive' | 'negative' | 'neutral';
  noColors?: boolean;
}

const QuestionPreviewContainer = (props: QuestionPreviewContainerProps) => {
  const { children, noColors, optionType, sx = [] } = props;

  return (
    <Box
      position="relative"
      height="100%"
      sx={[
        (theme) => ({
          backgroundColor: theme.check.palette.exercise.bgcolor(noColors ? undefined : optionType || 'none'),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      p={1}
    >
      {children}
    </Box>
  );
};

export default QuestionPreviewContainer;
